import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';

import { setUserProfile } from '../../../../redux/actions/authActions';
import buyersListActions from '../../../../redux/actions/buyersListActions';
import{
	_axiosCall
} from '../../../../shared/helpers/apicalls';
import{
	getLocalStorage,
	deleteLocalStorage
} from '../../../../shared/helpers/utils';
import{
	_getUserSSO,
	_setSSOToken,
	_getSSOToken,
	_getSSOOrg
} from '../../../../shared/components/auth/sso/ssoutils';
import { Publisher } from "./../../../pubsub/publisher.js";
import { _isNewDevSubscriber } from '../../../../shared/components/payment/plans';
import LinearLoading from '../../../../shared/components/LinearLoading';

const oktaToken = process.env.OKTA_TOKEN;

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchInProgress: false
    };
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }
  async login() {
    this.props.authService.login('/');
  }

  async logout() {
    this.props.authService.logout('/');
  }
  
  componentDidMount(){
	  const { authState, authService, dispatch, user, dataSet } = this.props;
	  const ssoToken = _getSSOToken();
	   if (!ssoToken) {
	      // When user isn't authenticated, forget any user info
	      //setUserInfo(null);
	      dispatch(setUserProfile(null));
	   }  else if(ssoToken && ssoToken.access_token && !user){
			_getUserSSO(ssoToken, this.props, setUserProfile).then(() => {
			   
			})
			 
	    }
			 
	  
  }
  
  
  
  _getUserMongoData = (user) => {
  		if(!user) return false;
        if (!this.state.fetchInProgress) {
		  this.setState(prevState => ({ fetchInProgress: true, }));
         }
      
        const { authState, authService, dispatch } = this.props;
      
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/userdata/${user.sub}`,
			method: "get"
		};

		 _axiosCall(axiosData)
			.then(res => {
				console.log('Data', res);
				if(res && res[0]){
					this.setState({ fetchInProgress : false });
					let mongoUser = Object.assign({}, res[0]);
					dispatch(buyersListActions.setUserData(mongoUser))
					
				}else{
					dispatch(buyersListActions.setUserData({}))
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});

   }

  render() {
	const { authService, authState, user } = this.props;
	const ssoOrg = _getSSOOrg();
	
	const ssoToken = _getSSOToken();	
    if ((ssoToken && !user)){
		return (
		<div className={`${ssoOrg === "ELLIMAN" ? "role-elliman-agent" : ""}`} style={{
		  display: 'flex',
		  flexDirection: 'column',
		  justifyContent: 'center',
		  alignItems: 'center',
		  width: '100vw',
		  height: '100vh',
		}}>
		  <div style={{ width: '100%', maxWidth: '1000px' }}>
			<LinearLoading />
		  </div>
		  {ssoOrg === "ELLIMAN" ?
		  <img
			  src="https://marketproof-hosting.s3.us-east-1.amazonaws.com/logos/MPxDE-lockup-dark.png"
			  alt="Marketproof Pro Logo"
			  style={{ marginTop: '20px', maxWidth: '500px', width: '100%' }}
			/>
		  
		  :
		  <img
			src="https://marketproof-hosting.s3.us-east-1.amazonaws.com/logos/marketproof-pro-logo.png"
			alt="Marketproof Pro Logo"
			style={{ marginTop: '20px', maxWidth: '300px', width: '100%' }}
		  />}
		</div>
);
	} 
    if (!(user && user.authType === 'sso')) return <Redirect  to={{ pathname: '/mplogin' }}/>;
    if(user === null) return null;
		   
	if(user && !_isNewDevSubscriber(user)){
		return <Redirect to={{ pathname: "/payment" }} />
	}else{
		Publisher.publish("login", user);	
		const redirect = getLocalStorage("mp", "redirect");	
		console.log(redirect)
		if(redirect){
			deleteLocalStorage("mp", "redirect");
			return <Redirect  to={{ pathname: redirect }}/> 
		}
		
		return <Redirect  to={{ pathname: '/dashboard' }}/> 
	}
    
/*
    return authState.isAuthenticated ?
    	 	 <Redirect  to={{ pathname: '/dashboard' }}/> :
    	 	 <Redirect  to={{ pathname: '/login' }}/> 
*/
    	

/*
    const button = this.props.authState.isAuthenticated ?
      <button onClick={this.logout}>Logout</button> :
      <button onClick={this.login}>Login</button>;

    return (
      <div>
        <Link to='/'>Home</Link><br/>
        <Link to='/protected'>Protected</Link><br/>
        {button}
      </div>
    );
*/
  }
}

export default connect(state => ({
  user: state.user
}))(withOktaAuth(Home))